import { Pipe, PipeTransform } from '@angular/core';
import { ItemProfile, ItemProperties, ItemResource, PropertyProfile } from '@ngx-hal/models';
import { PropertiesProfilesPipe } from '../properties-profiles/properties-profiles.pipe';

@Pipe({
  name: 'childProperty',
  standalone: false
})
export class ChildPropertyPipe implements PipeTransform {
  /**
   * Transforms the given `itemProfile` by filtering and finding a specific property profile
   * that matches the criteria based on the provided `propertyProfile`.
   *
   * @typeParam Entity - The type of the item resource.
   * @typeParam Property - The type of the item property for the given entity.
   * @param propertyProfile - The property profile to match against.
   * @param itemProfile - The item profile to be transformed and searched.
   * @returns The first item from the transformed `itemProfile` whose `alps.name` does not contain a dot
   *          and whose `alps.name` is a prefix of the `propertyProfile.alps.name` followed by a dot,
   *          or `undefined` if no such item is found.
   */
  transform<Entity extends ItemResource, Property extends ItemProperties<Entity>>(
    propertyProfile: PropertyProfile<Entity, Property>,
    itemProfile: ItemProfile<Entity>,
  ) {
    const profiles = new PropertiesProfilesPipe().transform(itemProfile);
    if (Array.isArray(profiles)) {
      return profiles
        .filter(item => item?.alps?.name && !item.alps.name.includes('.'))
        .find(item => item?.alps?.name && propertyProfile.alps.name.startsWith(item.alps.name + '.'));
    }
    return undefined;
  }
}
